<template>
    <v-dialog v-model="openDialog" persistent max-width="420px">
        <v-card>
            <div v-if="icon" class="pt-5">
                <v-icon class="mr-2 display-4">
                    mdi-alert-circle-outline
                </v-icon>
            </div>
            <v-card-text class="pb-0">
                <p class="headline text-center mb-0">{{ headline }}</p>
                <small text-center>{{ pretext }}</small>
                <v-container class="pb-0">
                    <v-text-field v-if="onAction!=='delete'"
                        id="listname"
                        v-model="listName"
                        label="List name*"
                        required
                    ></v-text-field>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    :color="onAction=='delete' ? 'red darken-1' : 'blue darken-1'"
                    text
                    @click.native="closemodal()"
                >{{ btnCloseText }}</v-btn>
                <v-btn
                    id="button-confirm"
                    :loading="loading"
                    :color="onAction=='delete' ? 'green darken-1' : 'blue darken-1'"
                    text
                    @click.native="savemodal()"
                >{{ btnSaveText }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        icon: {type: Boolean, default: false},
        btnSaveText: {type: String, default: 'Save'},
        btnCloseText: {type: String, default: 'Close'},
        onAction: {type: String, default: 'add'},
        headline: {type: String, default: ''},
        pretext: {type: String, default: ''},
        listName: {type: String, default: ''},
        loading: {type: Boolean, default: false},
        openDialog: {type: Boolean, default: false},
        closemodal: {type: Function, default: () => {
            this.openDialog = false
        }},
        okcallback: {type: Function, default: () => {
            this.openDialog = false
        }},
    },
    methods: {
        async savemodal(event) {
            try {
                await this.okcallback(this.listName)
            } catch {
                throw new Error('function callback.')
            }
        },
    },
}
</script>